import React, { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { style } from '../../api';
import Flex from '../common/Flex';
import Box from '../common/Box';
import { TextRegular } from '../common/Text';
import Slider from '../common/Slider';

interface BPMFilterProps {
  min?: number;
  max?: number;
  step?: number;
  initialMinValue?: number;
  initialMaxValue?: number;
  onChange?: ({
    minValue,
    maxValue,
  }: {
    minValue: number;
    maxValue: number;
  }) => void;
}

const BPMFilter = ({
  min = 60,
  max = 190,
  step = 1,
  initialMinValue,
  initialMaxValue,
  onChange = () => {},
}: BPMFilterProps) => {
  const { t } = useTranslation('common');
  const [value, setValue] = useState([
    initialMinValue || min,
    initialMaxValue || max,
  ]);

  const handleChange = (
    _event: React.ChangeEvent,
    newValue: [number, number],
  ) => {
    setValue(newValue as typeof value);
    if (newValue[0] && newValue[1]) {
      onChange({
        minValue: newValue[0],
        maxValue: newValue[1],
      });
    }
  };
  return (
    <Flex flexDirection="column" alignItems="center" width="100%">
      <Box width="100%">
        <Slider
          value={value as number[]}
          min={min}
          max={max}
          onChange={handleChange}
          step={step}
          marks={[min, max].map((val) => ({
            value: val,
            label: `${val}`,
          }))}
        />
      </Box>
      <Flex width="100%" px={2}>
        <Flex
          border="1px solid"
          borderColor={style.grey_light_1_new}
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          mx={1}
        >
          <Flex
            borderRight="1px solid"
            borderColor={style.grey_light_1_new}
            flex={1}
            alignItems="center"
            justifyContent="center"
            py={2}
            flexDirection="column"
          >
            <TextRegular fontWeight="bold">{value[0]}</TextRegular>
            <TextRegular mt={1} fontSize="12px" color={style.grey_dark_new}>
              {t('common:min')}
            </TextRegular>
          </Flex>
          <Flex
            py={2}
            flex={1}
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <TextRegular fontWeight="bold">{value[1]}</TextRegular>
            <TextRegular mt={1} fontSize="12px" color={style.grey_dark_new}>
              {t('common:max')}
            </TextRegular>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BPMFilter;
